<template>
  <v-container>

    <div class="d-flex align-center justify-space-between mb-3">
      <h2 class="mx-2 my-3">Roles</h2>
      <div>
        <v-btn color="primary" @click="openCreate = true">Crear</v-btn>
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="rolesStore.roles"
      :loading="rolesStore.loading"
      item-key="id"
      class="elevation-1"
    >
      <template #item.actions="{ item }">
        <v-menu>
          <template #activator="{ props }">
            <v-btn v-bind="props" icon variant="text">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list density="compact">
            <v-list-item @click="edit(item)">
              <v-list-item-title>Editar</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openPermissions(item)">
              <v-list-item-title>Permisos</v-list-item-title>
            </v-list-item>
            <!--v-list-item @click="askDelete(item)" color="error">
              <v-list-item-title class="text-error">Eliminar</v-list-item-title>
            </v-list-item-->
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <!-- Crear -->
    <v-dialog v-model="openCreate" width="520">
      <v-card>
        <v-card-title>Crear rol</v-card-title>
        <v-card-text>
          <v-text-field v-model="form.name" label="Nombre" />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn variant="text" @click="openCreate = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="saving" @click="saveCreate">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Editar -->
    <v-dialog v-model="openEdit" width="520">
      <v-card>
        <v-card-title>Editar rol</v-card-title>
        <v-card-text>
          <v-text-field v-model="form.name" label="Nombre" />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn variant="text" @click="openEdit = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="saving" @click="saveEdit">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmación eliminar -->
    <v-dialog v-model="openDelete" width="420">
      <v-card>
        <v-card-title>Eliminar rol</v-card-title>
        <v-card-text>
          ¿Seguro que deseas eliminar el rol <strong>{{ selected?.name }}</strong>?
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn variant="text" @click="openDelete = false">Cancelar</v-btn>
          <v-btn color="error" :loading="saving" @click="confirmDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Permisos -->
    <PermissionsDialog
      v-if="permissionsOpen"
      :role="selected!"
      @close="permissionsOpen = false"
    />
  </v-container>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue';
import { useRolesStore } from '@/store/roles';
import PermissionsDialog from './PermissionsDialog.vue';

const rolesStore = useRolesStore();

const headers = [
  { title: 'ID', value: 'id' },
  { title: 'Nombre', value: 'name' },
  { title: '', value: 'actions', sortable: false, align: 'end' },
];

const openCreate = ref(false);
const openEdit   = ref(false);
const openDelete = ref(false);
const permissionsOpen = ref(false);

const saving = ref(false);
const selected = ref<any>(null);

const form = reactive({ name: '', guard_name: '*' });

onMounted(() => {
  rolesStore.fetchRoles();
});

function resetForm() {
  form.name = '';
  form.guard_name = '*';
}

function edit(item: any) {
  selected.value = item;
  form.name = item.name || '';
  form.guard_name = item.guard_name || '*';
  openEdit.value = true;
}

function openPermissions(item: any) {
  selected.value = item;
  permissionsOpen.value = true;
}

function askDelete(item: any) {
  selected.value = item;
  openDelete.value = true;
}

async function saveCreate() {
  try {
    saving.value = true;
    await rolesStore.createRole({ ...form });
    openCreate.value = false;
    resetForm();
  } finally { saving.value = false; }
}

async function saveEdit() {
  if (!selected.value) return;
  try {
    saving.value = true;
    await rolesStore.updateRole(selected.value.id, { ...form });
    openEdit.value = false;
    selected.value = null;
    resetForm();
  } finally { saving.value = false; }
}

async function confirmDelete() {
  if (!selected.value) return;
  try {
    saving.value = true;
    await rolesStore.deleteRole(selected.value.id);
    openDelete.value = false;
    selected.value = null;
  } finally { saving.value = false; }
}
</script>
